import classNames from 'classnames';
import Heading from "../Heading/Heading";
import PostsGrid from "../PostsGrid/PostsGrid";
import Link from "next/link";

export default function RelatedStories({className, posts, seeMoreUrl}) {
  if (!posts?.length) return null;

  return (
    <div className={classNames(className)}>
      <div className={`flex flex-nowrap justify-between items-center mb-4 gap-5`}>
        <Heading level={'h3'} className={classNames('mom-section-heading mb-0')}>Related Stories</Heading>

        {seeMoreUrl && (
          <Link
            href={seeMoreUrl}
            className={`mom-btn mom-btn--sm shrink-0`}
          >
            See more
          </Link>
        )}
      </div>

      <PostsGrid posts={posts.slice(0, 8)} columnsPerRow={4} gridClassName={`grid-cols-2 xl:grid-cols-4`}/>
    </div>
  );
};
